import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import LocationIcon from '../../../../../icons/icon-location.svg';
import Button from '../../Button';


const fieldTypeMap = {
  zip: {
    type: 'text',
    label: 'Zip code',
    validationPattern: '(^\\d{5}$)|(^\\d{5}-\\d{4}$)',
    errorMessage: 'This is not a valid zip code',
  },
};

class SectionForm extends Component {
  constructor(props) {
    super(props);

    const {
      id,
      lookupMode,
      inputDescribedBy,
    } = this.props;

    this.field = fieldTypeMap[lookupMode];
    this.key = `opco_nav_location_${id}`;
    this.inputDescribedBy = inputDescribedBy;

    this.state = {
      editing: false,
      storedValue: '',
      error: false,
      errorMessage: '',
    };

    this.actionHandler = this.actionHandler.bind(this);
    this.focusHandler = this.focusHandler.bind(this);
    this.validate = this.validate.bind(this);
    this.blurHandler = this.blurHandler.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
  }

  actionHandler() {
    const { active, editActive } = this.props;

    if (!active) {
      editActive();

      return;
    }

    const { error, storedValue } = this.state;

    if (error || !storedValue) {
      this.setState({ editing: true });
      this.validate(storedValue);

      return;
    }

    const { id, submit } = this.props;

    const errorMessage = submit(id, storedValue);

    if (errorMessage) {
      this.setState({ error: true, errorMessage });
    } else {
      this.setState({ editing: false, storedValue: '' });
    }
  }

  focusHandler() {
    const { updateEditingStatus } = this.props;

    updateEditingStatus(true);
    this.setState({ editing: true });
  }

  validate(value) {
    const isValid = (new RegExp(this.field.validationPattern)).test(value);

    if (!isValid) {
      this.setState({ errorMessage: this.field.errorMessage });
    }

    this.setState({ error: !isValid });
  }

  blurHandler(event) {
    const { target: { value } } = event;

    this.setState({ storedValue: value });

    if (value) {
      this.validate(value);

      return;
    }

    const { updateEditingStatus } = this.props;

    updateEditingStatus(false);

    this.setState({ editing: false, error: false });
  }

  changeHandler(event) {
    const { target: { value } } = event;

    this.setState({ storedValue: value });

    const { error } = this.state;

    if (error) {
      this.validate(value);
    }
  }

  render() {
    const {
      editing, storedValue, error, errorMessage,
    } = this.state;
    const { active, value } = this.props;
    const buttonLabel = active ? 'Apply' : 'Update';
    const labelText = active ? this.field.label : value;
    const inputClassNames = classNames('opco-nav-form__section-field-input', {
      'opco-nav-form__section-field-input--disabled': !active,
      'opco-nav-form__section-field-input--error': error,
    });
    const labelClassNames = classNames('opco-nav-form__section-field-label', {
      'opco-nav-form__section-field-label--disabled': !active,
      'opco-nav-form__section-field-label--editing': editing,
      'opco-nav-form__section-field-label--error': error,
    });

    return (
      <div className="opco-nav-form__section-form" aria-describedby={this.inputDescribedBy}>
        <div className="opco-nav-form__section-field-wrapper">
          <label className={labelClassNames} htmlFor={this.key}>
            {!active && <LocationIcon className="opco-nav-form__location-icon" />}
            {labelText}
          </label>
          <input
            className={inputClassNames}
            type={this.field.type}
            id={this.key}
            name={this.key}
            disabled={!active}
            onFocus={this.focusHandler}
            onBlur={this.blurHandler}
            onChange={this.changeHandler}
            value={storedValue}
          />
        </div>
        <Button
          className="opco-nav-form__section-button"
          eventAction={this.actionHandler}
          label={buttonLabel}
        />
        {error && <span className="opco-nav-form__section-field-error">{errorMessage}</span>}
      </div>
    );
  }
}

SectionForm.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  lookupMode: PropTypes.string.isRequired,
  updateEditingStatus: PropTypes.func.isRequired,
  editActive: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  inputDescribedBy: PropTypes.string.isRequired,
};

SectionForm.defaultProps = {
};

export default SectionForm;
